import React from 'react';
import {
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Grid,
  Button,
  Dimmer,
  Loader,
  Segment,
  Input,
  Icon,
} from 'semantic-ui-react';
import { REGULAR_PATH } from '../../../env';
import ClickOutside from '../../helper/click-outside';
import { getData, handleMultipleRequest } from '../../helper/dataService';
import TemperatureGauge from '../dashboard/details/TemperatureGauge';
import moment from 'moment';
import { refreshToken } from '../../helper/refresh-token';
import { inject, observer } from 'mobx-react';
import * as ExcelJS from 'exceljs/dist/exceljs.js';

@inject('assets')
@observer
class Temperature extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      assets: [],
      selectAll: false,
      selected: [],
      search: '',
      openDropdown: false,
      temperatureData: [],
      loading: false,
    };
  }

  componentDidMount() {
    const assetList = this.props.assets.data;
    const assets = assetList.map((item) => ({
      id: item.value,
      value: item.value,
      label: item.label,
      checked: false,
    }));

    this.setState({ assets });

    this.IntervalID = setInterval(() => {
      if (this.state.temperatureData.length) {
        const selected = this.state.temperatureData.map((data) => data.id);
        this.getTemperatureData(selected);
      }
    }, 60000);
  }

  openDropdown = () => {
    this.setState({ openDropdown: true });
  };

  closeDropdown = () => {
    this.setState({ openDropdown: false, search: '' });
  };

  toggleDropdown = () =>
    this.setState({ openDropdown: !this.state.openDropdown });

  handleSearchChange = (e) => {
    e.stopPropagation();
    this.setState({ search: e.target.value });
  };

  handleSearchClick = (e) => {
    e.stopPropagation();
  };

  handleCheckboxChange = (id, e) => {
    e.stopPropagation();
    this.setState({ selectAll: false });
    const options = this.state.assets.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          checked: item.checked ? false : true,
        };
      } else {
        return item;
      }
    });

    const selected = options
      .filter((option) => option.checked)
      .map((option) => option.id);

    this.setState({ assets: options, selected });
  };

  handleSelectAll = (e) => {
    e.stopPropagation();
    const { assets, selectAll, search } = this.state;
    const filteredAssets = this.getFilteredAssets();

    if (selectAll) {
      this.setState({ selectAll: false });
      const options = assets.map((item) => {
        // Only uncheck filtered items if there's a search, otherwise uncheck all
        if (search) {
          const isInFiltered = filteredAssets.some(
            (filtered) => filtered.id === item.id,
          );
          return isInFiltered ? { ...item, checked: false } : item;
        } else {
          return { ...item, checked: false };
        }
      });
      const selected = options
        .filter((option) => option.checked)
        .map((option) => option.id);
      this.setState({ assets: options, selected });
    } else {
      this.setState({ selectAll: true });
      const options = assets.map((item) => {
        // Only check filtered items if there's a search, otherwise check all
        if (search) {
          const isInFiltered = filteredAssets.some(
            (filtered) => filtered.id === item.id,
          );
          return isInFiltered ? { ...item, checked: true } : item;
        } else {
          return { ...item, checked: true };
        }
      });
      const selected = options
        .filter((option) => option.checked)
        .map((option) => option.id);
      this.setState({ assets: options, selected });
    }
  };

  handleLabelClick = (id, e) => {
    e.preventDefault();
    e.stopPropagation();
    this.handleCheckboxChange(id, e);
  };

  handleSelectAllLabelClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.handleSelectAll(e);
  };

  getFilteredAssets = () => {
    const { assets, search } = this.state;
    if (!search) return assets;

    return assets.filter((asset) =>
      asset.label.toLowerCase().includes(search.toLowerCase()),
    );
  };

  getTemperatureData = (selected) => {
    let promises = [];

    for (let i = 0; i < selected.length; i++) {
      let id = selected[i];
      let url = `${REGULAR_PATH}/assets/${id}/last_data?access_token=`;
      promises.push(getData(url));
    }

    let lastDataResponse = handleMultipleRequest(promises);
    const data = [];

    return lastDataResponse
      .then((results) => {
        results.forEach((res) => {
          const temp = {
            id: res.data.asset_id,
            time: res.data.time,
            // name
            name: res.data.name,
            // temperature1
            temperature_1_enabled:
              res.data.temperature_sensor === 'True' ? true : false,
            temperature_1: res.data.temperature,
            temperature_1_name: res.data.temperature_sensor_name,
            // temperature2
            temperature_2_enabled:
              res.data.temperature_sensor_2 === 'True' ? true : false,
            temperature_2: res.data.temperature_2,
            temperature_2_name: res.data.temperature_sensor_2_name,
            // temperature3
            temperature_3_enabled:
              res.data.temperature_sensor_3 === 'True' ? true : false,
            temperature_3: res.data.temperature_3,
            temperature_3_name: res.data.temperature_sensor_3_name,
            // temperature4
            temperature_4_enabled:
              res.data.temperature_sensor_4 === 'True' ? true : false,
            temperature_4: res.data.temperature_4,
            temperature_4_name: res.data.temperature_sensor_4_name,
          };
          data.push(temp);
        });

        this.setState({ temperatureData: data });
      })
      .catch((error) => {
        if (error.response.data.error === 'expired token') {
          let extendedToken = refreshToken(
            `${REGULAR_PATH}/assets/${selected[0]
            }/last_data?access_token=${window.localStorage.getItem('user')}`,
          );
          extendedToken.then((res) => {
            this.generateLocationForMarker(selected);
          });
        }
      });
  };

  handleTemperatureData = async (selected) => {
    this.setState({ loading: true });
    await this.getTemperatureData(selected);
    this.setState({ loading: false });
  };

  downloadExcel = () => {
    const { temperatureData } = this.state;

    if (temperatureData.length === 0) {
      alert('No temperature data available to download');
      return;
    }

    const workbook = new ExcelJS.Workbook();
    workbook.creator = 'Finder GPS Tracking';
    workbook.created = new Date();
    workbook.addWorksheet('Temperature Report');
    const worksheet = workbook.getWorksheet('Temperature Report');

    // Add headers
    worksheet.addRow(['Finder GPS Tracking']);
    worksheet.addRow(['Temperature Dashboard']);
    worksheet.addRow([
      `Generated on ${moment().format('MMMM Do, YYYY, hh:mm:ss A')}`,
    ]);
    worksheet.addRow([`Generated By: ${window.localStorage.getItem('email')}`]);
    worksheet.addRow();
    worksheet.addRow();

    // Set column widths
    worksheet.columns = [
      { width: 10 }, // No
      { width: 30 }, // Asset Name
      { width: 25 }, // Temperature name
      { width: 15 }, // Temperature
      { width: 25 }, // Time
    ];

    // Add column headers
    const headerRow = worksheet.addRow([
      'No',
      'Asset Name',
      'Temperature name',
      'Temperature',
      'Time',
    ]);

    // Style header row
    headerRow.eachCell((cell) => {
      cell.font = {
        bold: true,
        color: { argb: 'FF000000' }, // Black
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'CCCCCC' }, // Gray
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    // Add data rows
    let rowNumber = 1;
    temperatureData.forEach((data) => {
      const temps = [];
      const formattedTime = moment(data.time)
        .utc(true)
        .local()
        .format('DD-MM-YYYY, hh:mm A');

      // Collect all enabled temperature sensors
      if (data.temperature_1_enabled && data.temperature_1) {
        temps.push({
          name: data.temperature_1_name || 'T1',
          value: data.temperature_1,
        });
      }
      if (data.temperature_2_enabled && data.temperature_2) {
        temps.push({
          name: data.temperature_2_name || 'T2',
          value: data.temperature_2,
        });
      }
      if (data.temperature_3_enabled && data.temperature_3) {
        temps.push({
          name: data.temperature_3_name || 'T3',
          value: data.temperature_3,
        });
      }
      if (data.temperature_4_enabled && data.temperature_4) {
        temps.push({
          name: data.temperature_4_name || 'T4',
          value: data.temperature_4,
        });
      }

      // Add rows for each temperature sensor
      temps.forEach((temp, index) => {
        worksheet.addRow([
          index === 0 ? rowNumber : '',
          index === 0 ? data.name : '',
          temp.name,
          `${temp.value}°C`,
          formattedTime,
        ]);
      });

      if (temps.length > 0) {
        rowNumber++;
      }
    });

    // Generate and download the file
    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: 'application/octet-binary',
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Temperature_Report_${moment().format(
        'MMMM_Do_YYYY_hh_mm_ss_A',
      )}.xlsx`;
      a.click();
      a.remove();
    });
  };

  render() {
    const {
      assets,
      selected,
      openDropdown,
      temperatureData,
      selectAll,
      loading,
      search,
    } = this.state;

    const totalSelected = selected.length;
    const filteredAssets = this.getFilteredAssets();

    const isOrg = ['66e2a431faf103d2b7178958', '6a802809646454758012e38b', '6a2a51a16464544e9b309cf1', '6ac4a581646454a24c410798', '6995aa4a6464547f136eb0cf'].includes(
      window.localStorage.getItem('organization'),
    );
    if (!isOrg) {
      return <h2>You are not authorized person.</h2>;
    }

    return (
      <div style={{ padding: 10 }}>
        <Segment>
          <div
            style={{
              display: 'flex',
              gap: 10,
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                display: 'flex',
                gap: 10,
                width: '33.33%',
              }}
            >
              <ClickOutside handleEvent={this.closeDropdown}>
                <div
                  style={{
                    border: '1px solid gray',
                    padding: '5px 10px',
                    borderRadius: 5,
                    width: '100%',
                  }}
                >
                  <Dropdown
                    trigger={
                      <span
                        onClick={this.toggleDropdown}
                        style={{
                          fontWeight: 600,
                        }}
                      >
                        {totalSelected > 0
                          ? `${totalSelected} SELECTED`
                          : 'SELECT ASSET'}
                      </span>
                    }
                    open={openDropdown}
                    pointing
                    onOpen={() => this.setState({ openDropdown: true })}
                    onClose={() =>
                      this.setState({ openDropdown: false, search: '' })
                    }
                  >
                    <DropdownMenu
                      style={{
                        maxHeight: 500,
                        overflowY: 'scroll',
                        position: 'absolute',
                        left: 0,
                      }}
                    >
                      <div
                        style={{
                          padding: '10px',
                          borderBottom: '1px solid #eee',
                          position: 'sticky',
                          top: 0,
                          backgroundColor: 'white',
                          zIndex: 10,
                        }}
                        onClick={this.handleSearchClick}
                      >
                        <Input
                          icon='search'
                          iconPosition='left'
                          placeholder='Search assets...'
                          value={search}
                          onChange={this.handleSearchChange}
                          onClick={this.handleSearchClick}
                          size='small'
                          style={{ width: '100%' }}
                        />
                        {search && (
                          <div
                            style={{
                              fontSize: '12px',
                              color: '#666',
                              marginTop: '5px',
                            }}
                          >
                            {filteredAssets.length} of {assets.length} assets
                            shown
                          </div>
                        )}
                      </div>
                      <DropdownItem
                        onClick={(e) => e.stopPropagation()}
                        content={
                          <label
                            onClick={this.handleSelectAllLabelClick}
                            style={{
                              cursor: 'pointer',
                              width: '100%',
                              display: 'block',
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10,
                              }}
                            >
                              <input
                                type='checkbox'
                                checked={selectAll}
                                onChange={this.handleSelectAll}
                                onClick={(e) => e.stopPropagation()}
                              />
                              {search
                                ? `Select All Filtered (${filteredAssets.length})`
                                : 'Select All'}
                            </div>
                          </label>
                        }
                      />
                      {filteredAssets.length === 0 && search ? (
                        <DropdownItem
                          content={
                            <div
                              style={{
                                fontStyle: 'italic',
                                color: '#999',
                                textAlign: 'center',
                                padding: '20px',
                              }}
                            >
                              No assets found matching "{search}"
                            </div>
                          }
                        />
                      ) : (
                        filteredAssets.map(({ id, label, checked }) => (
                          <DropdownItem
                            key={id}
                            value={id}
                            onClick={(e) => e.stopPropagation()}
                            content={
                              <label
                                onClick={(e) => this.handleLabelClick(id, e)}
                                style={{
                                  cursor: 'pointer',
                                  width: '100%',
                                  display: 'block',
                                }}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 10,
                                  }}
                                >
                                  <input
                                    type='checkbox'
                                    checked={checked}
                                    onChange={(e) =>
                                      this.handleCheckboxChange(id, e)
                                    }
                                    onClick={(e) => e.stopPropagation()}
                                  />
                                  {label}
                                </div>
                              </label>
                            }
                          />
                        ))
                      )}
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </ClickOutside>
              <Button
                color='teal'
                size='mini'
                onClick={() => this.handleTemperatureData(this.state.selected)}
                disabled={this.state.assets.length === 0}
              >
                Submit
              </Button>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                width: '33.33%',
              }}
            >
              <h3>Temperature Dashboard</h3>
            </div>
            <div
              style={{
                width: '33.33%',
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <Button
                color='green'
                size='mini'
                onClick={this.downloadExcel}
                disabled={temperatureData.length === 0}
              >
                <Icon name='download' />
                Download Excel
              </Button>
            </div>
          </div>
        </Segment>
        {loading ? (
          <>
            <Dimmer active={true}>
              <Loader indeterminate size='big'>
                Loading...
              </Loader>
            </Dimmer>
          </>
        ) : (
          temperatureData.map((data) => (
            <div
              key={data.name}
              style={{
                width: '100%',
              }}
            >
              <div
                style={{
                  background: 'white',
                  marginBottom: 20,
                  paddingTop: 10,
                  borderRadius: 5,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '10px 20px',
                  }}
                >
                  <div>
                    <span style={{ fontWeight: 'bold' }}>{data.name}</span>
                  </div>
                  <div>
                    <span style={{ fontWeight: 'bold' }}>Updated at: </span>
                    {moment(data.time)
                      .utc(true)
                      .local()
                      .format('DD-MM-YYYY, hh:mm A')}
                  </div>
                </div>

                <hr style={{ borderTop: '1px solid #F5F5F5' }} />
                {!data.temperature_1 &&
                  !data.temperature_2 &&
                  !data.temperature_3 &&
                  !data.temperature_4 ? (
                  <div style={{ padding: 20 }}>No Data Found</div>
                ) : (
                  <Grid columns={4} style={{ width: '100%' }}>
                    {data.temperature_1_enabled ? (
                      <Grid.Column>
                        <div>
                          <TemperatureGauge
                            name={
                              data.temperature_1_name
                                ? data.temperature_1_name
                                : 'Temperature 1'
                            }
                            value={data.temperature_1}
                          />
                        </div>
                      </Grid.Column>
                    ) : null}
                    {data.temperature_2_enabled ? (
                      <Grid.Column>
                        <div>
                          <TemperatureGauge
                            name={
                              data.temperature_2_name
                                ? data.temperature_2_name
                                : 'Temperature 2'
                            }
                            value={data.temperature_2}
                          />
                        </div>
                      </Grid.Column>
                    ) : null}
                    {data.temperature_3_enabled ? (
                      <Grid.Column>
                        <div>
                          <TemperatureGauge
                            name={
                              data.temperature_3_name
                                ? data.temperature_3_name
                                : 'Temperature 3'
                            }
                            value={data.temperature_3}
                          />
                        </div>
                      </Grid.Column>
                    ) : null}
                    {data.temperature_4_enabled ? (
                      <Grid.Column>
                        <div>
                          <TemperatureGauge
                            name={
                              data.temperature_4_name
                                ? data.temperature_4_name
                                : 'Temperature 4'
                            }
                            value={data.temperature_4}
                          />
                        </div>
                      </Grid.Column>
                    ) : null}
                  </Grid>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    );
  }
}

export default Temperature;
